import React from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import { Button, Typography } from '@material-ui/core';
import Image from '../Image';
import useStyles from './EmptyState.styles';

const EmptyState = props => {
  const {
    image,
    title,
    subtitle,
    primaryAction,
    secondaryAction,
    titleProps,
    subtitleProps,
    position,
  } = props;
  const { className: imgClassName, ...otherImageProps } = image || {};
  const classes = useStyles();

  const primaryActionMarkup = primaryAction ? <Button color="primary" {...primaryAction} /> : null;

  const secondaryActionMarkup = secondaryAction ? (
    <Button color="primary" {...secondaryAction} />
  ) : null;

  const renderActions = () =>
    primaryAction || secondaryAction ? (
      <div className={classes.actions}>
        {secondaryActionMarkup}
        {primaryActionMarkup}
      </div>
    ) : null;

  return (
    <div
      className={cn({
        [classes.fixed]: position === 'fixed',
      })}
    >
      {image && <Image className={cn(classes.img, imgClassName)} {...otherImageProps} />}
      {title && (
        <Typography variant="h5" align="center" {...titleProps}>
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography variant="h6" align="center" {...subtitleProps}>
          {subtitle}
        </Typography>
      )}
      {renderActions()}
    </div>
  );
};

EmptyState.propTypes = {
  position: Type.oneOf(['static', 'absolute', 'relative', 'fixed']),
  image: Type.shape(Image.propTypes),
  title: Type.string,
  subtitle: Type.string,
  primaryAction: Type.object, // eslint-disable-line react/forbid-prop-types,
  secondaryAction: Type.object, // eslint-disable-line react/forbid-prop-types,
  titleProps: Type.object, // eslint-disable-line react/forbid-prop-types,
  subtitleProps: Type.object, // eslint-disable-line react/forbid-prop-types,
};

EmptyState.defaultProps = {
  position: 'static',
  image: null,
  title: '',
  subtitle: '',
  titleProps: {},
  subtitleProps: {},
  primaryAction: null,
  secondaryAction: null,
};

export default EmptyState;
